import { useEffect } from "react";
import { i18n } from "../../../../config";

import { MenuItem, Select, FormControl, InputLabel, FormHelperText } from "@mui/material"
import { useAccessTariffs } from "../../hooks/data/useAccessTariffs";
import { Controller, useFormContext } from "react-hook-form";

type AccessTariffsSelectProps = {
  gas: false;
  power: {
    power: number;
    power2: number;
    power3?: number;
    power4?: number;
    power5?: number;
    power6?: number;
  };
  label: string;
  readOnly?: boolean;
} | {
  gas: true,
  power?: {};
  label: string;
  readOnly?: boolean;
}

const AccessTariffSelectField = ({
  label, 
  readOnly = false,
  gas = false,
  power = {}
}: AccessTariffsSelectProps) => {

  const { 
    control,
    setValue,
    getValues
  } = useFormContext();

  const accessTariffsData = useAccessTariffs({

    // power is a dict '{power: 12, power2: 13, ...}. We need to transform the dict into an array Object.values(),
    // filter those powers which are undefined or null, finally spread the 
    // final array to pass the powers as singular arguments into the Math.max function.'
    power: Math.max(...Object.values(power).map(pow => pow)),
    gas

  });

  useEffect(() => {
    if (
      accessTariffsData.isSuccess && 
      !accessTariffsData.data.filter(tariff => tariff.id == getValues("accessTariff")).length
    ) {
      setValue("accessTariff", '');
    }
  }, [accessTariffsData.data])

  return (
    <Controller
      name={"accessTariff"}
      control={control}
      rules={{ required: true }}
      render={({ field, fieldState }) => <>
        <FormControl
          disabled={readOnly}
          style={{width: "100%"}}
        >
          <InputLabel shrink htmlFor="">
            {(label || i18n.t('common:text.contractation_access_tariff')) + "*"}
          </InputLabel>
          <Select
            autoWidth={true}
            error={!!fieldState.error}
            disabled={
              accessTariffsData.isSuccess && accessTariffsData.data.length === 0 || 
              accessTariffsData.isLoading
            }
            {...field}
          >
            {(accessTariffsData.isSuccess && accessTariffsData.data.length &&
              accessTariffsData.data.map((c) => {
                return <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>;
              })) ||
              []}
          </Select>
        </FormControl>
        {fieldState.error?.message &&
          <FormHelperText error={true}>
            {fieldState.error.message}
          </FormHelperText>
        }
      </>}
    />
  );
};

export default AccessTariffSelectField;
